<template>
    <div class="pp-lottery-winnings">
        <DsTable>
            <DsRow>
                <DsCell type="th">Pořadí</DsCell>
                <DsCell type="th">Výhra</DsCell>
                <DsCell type="th">Uhodnuto</DsCell>
            </DsRow>
            <DsRow v-for="(winning, index) in results.mainGameWinnings[0]" :key="index">
                <DsCell>{{ index + 1 }}.&nbsp;pořadí</DsCell>
                <DsCell>
                    <strong v-if="winning.amount && winning.wins" v-html="formatAmount(winning.amount)"></strong>
                    <template v-else>–––</template>
                </DsCell>
                <DsCell>
                    <div
                        v-if="winning.amount && winning.wins"
                        v-html="StringUtils.formatNumber(winning.wins) + 'x'"
                    ></div>
                    <template v-else>–––</template>
                </DsCell>
            </DsRow>
        </DsTable>
        <PpSpecialPrizeWinnings
            :lottery="Lottery.extraRenta"
            :specialPrizes="results.specialPrizes"
        ></PpSpecialPrizeWinnings>
    </div>
</template>

<script lang="ts" setup>
import { PpDraw } from "@/lotteries/services/model/draw";
import { StringUtils } from "@sazka/utils/string-utils";
import DsTable from "@sazka/design-system/src/table/ds-table.vue";
import DsRow from "@sazka/design-system/src/table-row/ds-table-row.vue";
import DsCell from "@sazka/design-system/src/table-cell/ds-table-cell.vue";
import PpSpecialPrizeWinnings from "./pp-special-prize-winnings.vue";
import { Lottery } from "@sazka/lotteries/js/models/lottery";

defineProps<{
    results: PpDraw;
}>();

const formatAmount = (amount: number) => {
    return `${StringUtils.formatCurrency(amount)}&nbsp;/ ${StringUtils.formatCurrency(amount * 2)}`;
};
</script>
